module.exports = __webpack_public_path__ + "static/img/empty-list.73a7c3a.png";